import { SelfServiceUserAccount } from '@ekt-group/general-purpose-api-interfaces';
import { CustomerContractRole } from '@ekt-group/general-purpose-api-interfaces/src/types/customer-contract-role.enum';
import { Building05, User01 } from '@untitled-ui/icons-react';
import { ComponentProps } from 'react';

import { cn } from '@/utils/cn';

import { ExtendedSelfServiceUserAccount } from './UserAccountList';

interface UserAccountProps extends Omit<ComponentProps<'div'>, 'onClick'> {
  account: ExtendedSelfServiceUserAccount;
  onClick: (account: SelfServiceUserAccount) => void;

  isSearching?: boolean;
  isSelected?: boolean;
}

export const UserAccount = ({ account, onClick, className, isSearching, isSelected, ...rest }: UserAccountProps) => {
  const icon =
    account.originalObject.role === CustomerContractRole.ContractOwner ||
    account.originalObject.role === CustomerContractRole.AuthorisedPerson ? (
      <User01 />
    ) : (
      <Building05 />
    );

  return (
    <div
      className={cn(
        'flex items-center justify-between gap-2 px-1 py-3 border-b cursor-pointer hover:bg-brand-green-light border-b-brand-brown-light',
        { 'bg-brand-green-hover/30 ': isSelected },
        className,
      )}
      onClick={() => onClick(account.originalObject)}
      {...rest}
    >
      <span className="text-brand-brown">{icon}</span>
      <div className="flex flex-col flex-1 justify-between">
        <span
          className={cn('text-base', {
            'font-semibold': !isSearching,
          })}
          dangerouslySetInnerHTML={{ __html: account?.highlightedObject.name }}
        ></span>
        <span
          className="text-brand-brown text-sm"
          dangerouslySetInnerHTML={{ __html: `${account.highlightedObject.type}, ${account.highlightedObject.code}` }}
        ></span>
      </div>
    </div>
  );
};
